var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.411 11.59l-.858-.685a1.149 1.149 0 010-1.809l.858-.685a1.525 1.525 0 00.372-1.988l-1.7-2.846a1.632 1.632 0 00-1.956-.677l-1.041.378a1.212 1.212 0 01-1.617-.9l-.183-1.063A1.593 1.593 0 0011.695 0h-3.39a1.593 1.593 0 00-1.59 1.306l-.183 1.063a1.212 1.212 0 01-1.617.9L3.874 2.9a1.632 1.632 0 00-1.962.682L.218 6.423A1.525 1.525 0 00.589 8.41l.858.69a1.149 1.149 0 010 1.809l-.858.685a1.525 1.525 0 00-.372 1.988l1.7 2.846a1.632 1.632 0 001.962.682l1.041-.378a1.212 1.212 0 011.617.9l.183 1.063A1.593 1.593 0 008.305 20h3.39a1.593 1.593 0 001.59-1.306l.183-1.063a1.212 1.212 0 011.617-.9l1.042.369a1.632 1.632 0 001.962-.682l1.7-2.846a1.525 1.525 0 00-.372-1.988zm-2.72 4.052l-1.041-.378a2.828 2.828 0 00-3.772 2.111l-.183 1.063h-3.39l-.178-1.063a2.828 2.828 0 00-3.772-2.111l-1.041.378-1.7-2.842.858-.685a2.681 2.681 0 000-4.222L1.614 7.2l1.7-2.846 1.041.378a2.828 2.828 0 003.772-2.106l.183-1.063h3.39l.183 1.063a2.828 2.828 0 003.772 2.111l1.041-.378L18.387 7.2l-.858.685a2.681 2.681 0 000 4.222l.858.685z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6.015)",
    stroke: "#a1ff00",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3
  }))));
}
export default SvgSetup;